export default function FormContainer({ id = "", handleSubmit = "", children }) {
  return (
    <div className="container">
      <form id={`${id}-form`} onSubmit={handleSubmit}>
        <div className="row">{children}</div>
      </form>
    </div>
  );
}
